import { createGlobalStyle } from "styled-components";

export const primaryColor = "#0ea5e9"; // Highlight color

const GlobalStyle = createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    html {
        @media (max-width: 1700px) {
            font-size: 67%;
        }
        @media (max-width: 1300px) {
            font-size: 62%;
        }
        @media (max-width: 768px) {
            font-size: 55%;
        }
    }


    body {
        background-color: #1b1b1b;
        font-family: 'Inter', sans-serif;
        overflow-x: hidden;
    }

    button {
        font-weight: bold;
        font-size: 1.1rem;
        cursor: pointer;
        padding: 1rem 2rem;
        border: 3px solid ${primaryColor};
        background: transparent;
        color: #fff;
        transition: all 0.5s ease;

        &:hover {
            background: ${primaryColor};
            color: #fff;
        }

        @media (max-width: 768px) {
            padding: 0.8rem 1.5rem;
            font-size: 1rem;
        }
    }

    a {
        font-size: 1.1rem;
    }
    
    span {
        font-weight: bold;
        color: ${primaryColor};
    }

    h2 {
        font-weight: lighter;
        font-size: 4rem;

        @media (max-width: 1300px) {
            font-size: 3rem;
        }

        @media (max-width: 768px) {
            font-size: 2.5rem;
        }
    }

    h3 {
        color: #fff;
    }

    h4 {
        font-weight: bold;
        font-size: 2rem;
    }

    p {
        color: #ccc;
        padding: 3rem 0rem;
        font-size: 1.4rem;
        line-height: 150%;

        @media (max-width: 1300px) {
            padding: 2rem 0rem;
            font-size: 1.2rem;
        }

        @media (max-width: 768px) {
            padding: 1.5rem 0rem;
            font-size: 1.1rem;
        }
    }

`;

export default GlobalStyle;
